export default import.meta.ROLLDOWN_FILE_URL_4ui$OgT6pBc8ys_iMN8YZQ